<template>
  <modal-vue>
    <h3 slot="header">Nova dúvida</h3>

    <div slot="body">
      <div class="form-group">
        <label for="questionText">Texto</label>
        <textarea v-model="question.text" class="form-control" id="questionText" rows="5"></textarea>
      </div>
    </div>

    <div slot="footer">
      <lms-button @click="saveQuestion()" :loading="savingQuestion">Salvar</lms-button>
      <button class="btn btn-default" @click="$emit('closeModal');">Cancelar</button>
    </div>
  </modal-vue>
</template>

<script>
import axios from "axios";

export default {
  props: ["videoId"],
  components: {
  },
  data() {
    return {
      savingQuestion: false,
      question: {}
    };
  },
  methods: {
    saveQuestion() {
      this.question.videoId = this.videoId;
      this.savingQuestion = true;
      const path = this.$global.endpoint + "/lesson/question/create";
      axios
        .post(path, {
          question: this.question
        })
        .then(res => {
          this.savingQuestion = false;
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Dúvida cadastrada com sucesso"
          });
          this.$emit("closeModal");
        })
        .catch(error => {
          this.savingQuestion = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    }
  }
};
</script>
